module.exports = __webpack_public_path__ + "static/media/ic-biome-weight-apeiron-scale.31500d8e.svg";